import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
 
 
  box-sizing: border-box;
  width:60%;
  margin: 0 auto;

  @media (max-width: 500px) {
    width:90%;
    padding: 0%;
  }
`;


const Title = styled.h2`
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 70px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  
  


  span{
    color: #FFF56A;
  }

  @media (max-width: 500px) {
    width:70%;
    font-size: 32px;
    line-height: 40px;
    padding:10% 0% 10% 0%;
    margin: 0 auto;

  }


`;

const GoalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  position: relative; 

  @media (max-width: 500px) {
    flex-direction: row; 
    gap: 8px;


  }
`;

const GoalCard = styled.div`
  position: relative;
  flex: 1;
  max-width: calc(33% - 2px);
  background-color: #1F1F1F;
  border-radius: 30px;

  
  overflow: hidden;
  margin-bottom: 24px;



  @media (max-width: 500px) {
    box-sizing: border-box;
    flex: calc(100% - 0px);
    max-width: 100%;
    margin-bottom: 8px; 
 
  }




`;



const GoalImage = styled.img`
  width: 40%;
  height: auto;
  object-fit: cover;
  margin-bottom: 0px;
  padding:10% 10% 0% 10%;

  @media (max-width: 500px) {
   
    max-width: 100%; /* 調整圖片最大寬度 */
    height: auto; /* 確保高度按比例縮放 */
    padding:10% 5% 0% 5%;
  }
`;


const GoalText = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  color: #FFFFFF;
  align-items: flex-start;
  padding: 0% 10% 0% 10%;
  gap: 8px;
  margin-bottom: 16px;
  position: relative; 

  @media (max-width: 500px) {
    font-size: 14px;
    padding:0% 5% 5% 5%;
    gap: 0px;
    line-height: 24px;
 
  }


`;



const DIDSection3 = () => (
  <SectionWrapper>
    
    <Title>DID 分散式身分的優勢<span>.</span></Title>
    <GoalContainer>
      {/* Goal 1 */}
      <GoalCard>
        <GoalImage src="/images/DIDSec3_1.png" alt="Goal 1" />
        <GoalText>無論是面對人工智慧假造身分及消息的威脅，或是全球急遽加速的戰爭及氣候危機，人們對於身分的掌控都應該更加安全與具有韌性，以對抗操弄或毀損。</GoalText>
        
       
      </GoalCard>

      {/* Goal 2 */}
      <GoalCard>
        <GoalImage src="/images/DIDSec3_2.png" alt="Goal 2" />
        <GoalText>在全球隱私保護的趨勢下，保護個人和消費者的資料已成為核心焦點。隨著各種新工具和法規的出現，人們有更多可能的方式保護個人的隱私，身分框架必須要與隱私考量緊緊相扣。</GoalText>
     
      </GoalCard>

      {/* Goal 3 */}
      <GoalCard>
        <GoalImage src="/images/DIDSec3_3.png" alt="Goal 3" />
        <GoalText>早先進行數位民主領域研究與實踐的人們，提出對於數位民主的想像與建議包含：擁有更真實的社會對話、更貼近需求的資源分配，還有更加利他的社會機制。為了讓這些想像實現，我們必須讓身分架構在安全且保有隱私的前提下，更加互通、高效且開放，也為未來的堆疊優化建立穩固基礎。</GoalText>
   
      </GoalCard>

  
    </GoalContainer>
  </SectionWrapper>
);

export default DIDSection3;
